<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">调用接口</h1>
		<h2 class="doc_main_h2">识别一个 BGR、倒立、无行对齐位数据格式图像</h2>
		<h3 class="doc_main_h3">1.直接调用</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">char *SKEyeSDK_Image(unsigned char *ImageData, unsigned
int ImageWidth, unsigned int ImageHeight,char * ServiceName);
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）ImageData：BGR、倒立、无行对齐,图片数据</p>
        <p class="doc_main_p">（2）ImageWidth：图片的宽度</p>
        <p class="doc_main_p">（3）ImageHeight: 图片的高度</p>
        <p class="doc_main_p">（4）ServiceName：识别服务名称</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">2.接口回调</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">Void SKEyeSDK_Image(unsigned char *ImageData, unsigned 
int ImageWide, unsigned int ImageHight, char
*ServiceName, CallBackImageResult ImageResult);  
Void SKEyeSDK_Image(int ImageId,unsigned char *ImageData,
unsigned int ImageWide, unsigned int ImageHight, char
*ServiceName, CallBackImageResult ImageResult);
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）ImageId：图片 Id（方便确认请求顺序和返回顺序是否一致）</p>
        <p class="doc_main_p">（2）ImageData：BGR、倒立、无行对齐,图片数据 </p>
        <p class="doc_main_p">（3）ImageWidth：图片的宽度 </p>
        <p class="doc_main_p">（4）ImageHeight: 图片的高度 </p>
        <p class="doc_main_p">（5）ServiceName：识别服务名称 </p>
        <p class="doc_main_p">（6）ImageResult：回调接口 </p>

        <h4 class="doc_main_h4">接口回调返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">直接调用示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 直接调用
unsigned char *ImageData; unsigned int ImageWith,ImageHeight; char ImageUrl[]=”4.bmp”;
//GetImageData 获取 BGR、倒立、无行对齐 图像数据
if(!GetImageData(ImageUrl,ImageData,ImageWidth, ImageHeight))
{	
	printf("Open is error\n"); return 0;
}
char ApiKey[] = "466da4221010f8341912da500b4a23b"; 
char ApiSecret[] = "ddc8bd498e7c29c929862ab7391a7b89"; SKEyeSDK_Init(ApiKey, ApiSecret);
char*ImageJsonData= SKEyeSDK_Image(ImageData, ImageWith, ImageHeight, ServiceName);</code></pre>
		<h3 class="doc_main_h3">接口回调示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//接口回调
void CallBackImageResultFunction (char *ImageResult)
{
//这里添加代码printf("%s\n", ImageResult);
} unsigned char *ImageData; Int ImageId=1;
unsigned int ImageWith,ImageHeight; char ImageUrl []=”4.bmp”;
//GetImageData 获取 BGR、倒立、无行对齐 图像数据
if (!GetImageData(ImageUrl,ImageData,ImageWidth, ImageHeight))
{	printf("Open is error\n"); return;
} char ApiKey[] = "466da4221010f8341912da500b4a23b";
SKEyeSDK_Init(ApiKey, ApiSecret);
//回调
SKEyeSDK_Image(ImageData,ImageWith,ImageHeight, ServiceName, CallBackImageResultFunction);  
//回掉图片 Id（方便确认请求顺序和返回顺序是否一致） 
SKEyeSDK_Image(ImageId,ImageData,ImageWith,ImageHeight, ServiceName, CallBackImageResultFunction); 
</code></pre>

        <h2 class="doc_main_h2">识别一个 url（网络 url、本地路径）图像</h2>
        <h3 class="doc_main_h3">1.直接调用</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">char *SKEyeSDK_ImagePath(char * UrlOrLocalPath, char
*ServiceName);</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）UrlOrLocalPath：图像的 url（网络 url 或者本地路径）</p>
        <p class="doc_main_p">（2）ServiceName：识别服务名称</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>

        <h3 class="doc_main_h3">2.接口回调</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">typedef void(*CallBackImageResult)(char *ImageResult); 
void SKEyeSDK_ImagePath(char *UrlOrLocalPath, char *ServiceName, CallBackImageResult ImageResult);
void SKEyeSDK_ImagePath(int ImageId,char *UrlOrLocalPath, 
	char *ServiceName, CallBackImageResult ImageResult);
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）ImageId：图片 Id（方便确认请求顺序和返回顺序是否一致）</p>
        <p class="doc_main_p">（2）UrlOrLocalPath：图像的 url（网络 url 或者本地路径）</p>
        <p class="doc_main_p">（3）ServiceName：识别服务名称</p>
        <p class="doc_main_p">（4）ImageResult：回调接口</p>
        <h4 class="doc_main_h4">接口回调返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">直接调用示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// ImageUrl（网络 url 或者本地路径）
char ImageUrl [] = "object3.jpg"; char ServiceName[] = "objects";	
char *ImageResult=NULL; char ApiKey[] = "466da4221010f8341912da500b4a23b"; 
char ApiSecret[] = "ddc8bd498e7c29c929862ab7391a7b89";
SKEyeSDK_Init(ApiKey, ApiSecret);
ImageResult =SKEyeSDK_ImagePath(ImageUrl,ServiceNames);
</code></pre>
		<h3 class="doc_main_h3">直接调用示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// ImageUrl（网络 url 或者本地路径）
Int ImageId=0;
char ImageUrl [] = "object3.jpg"; char ServiceName[] = "objects";
void CallBackImageResultFunction (char * ImageResult)
{
	printf("%s\n", ImageResult);
}
char ApiKey[] = "466da4221010f8341912da500b4a23b"; 
char ApiSecret[] = "ddc8bd498e7c29c929862ab7391a7b89";
SKEyeSDK_Init(ApiKey, ApiSecret);
//回掉
SKEyeSDK_ImagePath(ImageUrl, ServiceName, CallBackImageResultFunction);
//回掉图片 Id（方便确认请求顺序和返回顺序是否一致）
SKEyeSDK_ImagePath(ImageId ,ImageUrl, ServiceName, CallBackImageResultFunction);
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	import SKEyeJson from '../../../components/SKEyeJson'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'sk-eye-json':SKEyeJson,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-Linux','调用接口'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyelinux/callImageInterface.vue